import React, { useState, useEffect } from 'react';
import { cn } from "@/lib/utils";
import { ShoppingCart, Menu, X } from "lucide-react";
import { Link } from 'react-router-dom';
import { Button } from '@/components/ui/button';

const Navbar = () => {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

  // Handle scroll effect
  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 10);
    };
    
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  return (
    <header 
      className={cn(
        "fixed top-0 left-0 right-0 z-50 transition-all duration-300 ease-in-out",
        isScrolled 
          ? "bg-white/80 backdrop-blur-md shadow-sm py-3" 
          : "bg-transparent py-5"
      )}
    >
      <div className="container mx-auto px-4 flex items-center justify-between">
        {/* Logo */}
        <Link to="/" className="text-marine font-bold text-2xl">
          Marine Fuel Boost
        </Link>
        
        {/* Desktop Navigation */}
        <nav className="hidden md:flex space-x-8 items-center">
          <a href="#products" className="text-marine hover:text-marine-light transition-colors">Products</a>
          <a href="#benefits" className="text-marine hover:text-marine-light transition-colors">Benefits</a>
          <a href="#testimonials" className="text-marine hover:text-marine-light transition-colors">Testimonials</a>
          <button 
            className="flex items-center space-x-2 bg-marine text-white py-2 px-4 rounded-md hover:bg-marine-light transition-colors"
            onClick={() => {
              const productsSection = document.querySelector('#products');
              if (productsSection) {
                productsSection.scrollIntoView({ behavior: 'smooth' });
              }
            }}
          >
            <ShoppingCart size={18} />
            <span>Buy Now</span>
          </button>
        </nav>
        
        {/* Mobile menu button */}
        <button 
          className="md:hidden text-marine" 
          onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
        >
          {isMobileMenuOpen ? <X size={24} /> : <Menu size={24} />}
        </button>
      </div>
      
      {/* Mobile menu */}
      {isMobileMenuOpen && (
        <div className="md:hidden bg-white absolute top-full left-0 right-0 shadow-lg animate-fade-in">
          <div className="container mx-auto px-4 py-4 flex flex-col space-y-4">
            <a 
              href="#products" 
              className="text-marine hover:text-marine-light transition-colors py-2 border-b border-gray-100"
              onClick={() => setIsMobileMenuOpen(false)}
            >
              Products
            </a>
            <a 
              href="#benefits" 
              className="text-marine hover:text-marine-light transition-colors py-2 border-b border-gray-100"
              onClick={() => setIsMobileMenuOpen(false)}
            >
              Benefits
            </a>
            <a 
              href="#testimonials" 
              className="text-marine hover:text-marine-light transition-colors py-2 border-b border-gray-100"
              onClick={() => setIsMobileMenuOpen(false)}
            >
              Testimonials
            </a>
            <button 
              className="flex items-center justify-center space-x-2 bg-marine text-white py-3 px-4 rounded-md hover:bg-marine-light transition-colors"
              onClick={() => {
                setIsMobileMenuOpen(false);
                const productsSection = document.querySelector('#products');
                if (productsSection) {
                  productsSection.scrollIntoView({ behavior: 'smooth' });
                }
              }}
            >
              <ShoppingCart size={18} />
              <span>Buy Now</span>
            </button>
          </div>
        </div>
      )}
    </header>
  );
};

export default Navbar;
